import { ForwardedRef, ReactNode } from 'react';
import styled from 'styled-components';
import { theme } from './dialog_modal.theme';

const StyledContent = styled.div`
	display: flex;
	flex-direction: column;
	flex-shrink: 1;
	overflow: auto;
	gap: ${theme.getValue('gap')};
	width: calc(100% + ${theme.getValue('padding')});
	padding: calc(${theme.getValue('gap')} / 2) calc(${theme.getValue('padding')} / 2);
	margin: calc(${theme.getValue('gap')} / -2) calc(${theme.getValue('padding')} / -2);
	font: ${theme.getValue('contentFont')};
	box-sizing: border-box;
`;

export interface DialogModalContentProps {
	children: ReactNode;
}

export function DialogModalContent({ children }: DialogModalContentProps, ref: ForwardedRef<HTMLDivElement>): JSX.Element {
	return <StyledContent ref={ref}>{children}</StyledContent>;
}
